interface ITelecomFeePlan {
  id: number;
  telecom: string;
  plan: string;
  basicFare: number;
  basicData: number;
  extraFee: number;
  extraFeeData: number;
  extraFeePer1mb: number;
}

export const telecomFeePlanOptions = [
  { value: 'LTE-M10|SKT', label: 'LTE-M10 (SKT)' },
  { value: 'LTE-M20|SKT', label: 'LTE-M20 (SKT)' },
  { value: 'LTE-M30|SKT', label: 'LTE-M30 (SKT)' },
  { value: 'LTE-M40|SKT', label: 'LTE-M40 (SKT)' },
  { value: 'LTE-M50|SKT', label: 'LTE-M50 (SKT)' },
  { value: 'IoT 모니터링 라이트|SKT', label: 'IoT 모니터링 라이트(무제한) (SKT)' },
  { value: 'IoT38|KT', label: 'IoT38 (KT)' },
  { value: 'IoT77|KT', label: 'IoT77 (KT)' },
  { value: 'IoT110|KT', label: 'IoT110 (KT)' },
  { value: 'IoT165|KT', label: 'IoT165 (KT)' },
];

export interface IParsedTelecomFeePlanOptionValue {
  plan: string;
  telecom: string;
}

export type { ITelecomFeePlan };
